import React from 'react'

import Image from 'next/image'

import { getItOnGooglePlayBadgeWebImage } from 'Assets/Images'

import { APP_LINK } from 'Constants/Ids'

import { StyledLink } from './styles'

function GooglePlayLink() {
  return (
    <StyledLink
      href={APP_LINK.GOOGLE_PLAY}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Image alt="Get it on Google Play" src={getItOnGooglePlayBadgeWebImage} />
    </StyledLink>
  )
}

export default GooglePlayLink
